import { StorageAdapterTypeConfiguration } from 'record-it-utils-custom-types';
import { assertNotNullOrUndefined } from 'record-it-utils/utils/assert/assertNotNullOrUndefined';
import { EntityManagerBaseEntity } from '../EntityManagerBaseEntity';

export class StorageAdapter {
  private static config: StorageAdapterConfig | null = null;

  private constructor() {}

  public static configure(config: StorageAdapterConfig): void {
    this.config = config;
  }

  public static async setGeneralItem(key: string, value: any): Promise<void> {
    await this.getConfig().setGeneralItem(key, value);
  }

  public static async setEntities(
    items: Array<EntityManagerBaseEntity>,
    entityName: StorageAdapterEntityName
  ): Promise<void> {
    await this.getConfig().setEntities(items, entityName);
  }

  public static async getGeneralItem<T = any>(
    key: string
  ): Promise<T | undefined> {
    return this.getConfig().getGeneralItem(key);
  }

  public static async getEntities<T = any>(
    entityName: StorageAdapterEntityName
  ): Promise<Array<T>> {
    return this.getConfig().getEntities(entityName);
  }

  public static async removeGeneralItem(key: string): Promise<void> {
    await this.getConfig().removeGeneralItem(key);
  }

  public static async removeEntities(
    entityIds: Array<string>,
    entityName: StorageAdapterEntityName
  ): Promise<void> {
    await this.getConfig().removeEntities(entityIds, entityName);
  }

  private static getConfig(): StorageAdapterConfig {
    assertNotNullOrUndefined(
      this.config,
      'no config available, did you forget to configure the StorageAdapter?'
    );

    return this.config;
  }
}

export type StorageAdapterEntityName =
  StorageAdapterTypeConfiguration['EntityName'];

export type StorageAdapterItem = {
  key: string;
  value: any;
};

export type StorageAdapterConfig = {
  setGeneralItem: (key: string, value: any) => Promise<void>;
  getGeneralItem: <T = any>(key: string) => Promise<T | undefined>;
  removeGeneralItem: (key: string) => Promise<void>;
  setEntities: (
    items: Array<EntityManagerBaseEntity>,
    entityName: StorageAdapterEntityName
  ) => Promise<void>;
  getEntities: <T = any>(
    entityName: StorageAdapterEntityName
  ) => Promise<Array<T>>;
  removeEntities: (
    entityIds: Array<string>,
    entityName: StorageAdapterEntityName
  ) => Promise<void>;
};
